module.exports = __webpack_public_path__ + "static/media/slide-1.ec9ca830.jpg";